// Vendors
import React from 'react';

const UpdateProjectStatus = ({
  projectData,
  openAccordion,
  handleToggleAccordion,
  newProjectStatus,
  setNewProjectStatus,
  projectMessage,
  setProjectMessage,
  handleUpdateStatus
}) => (
  <div className="grid__col-xs-12 u--margin-bottom-20">
    <button
      className={`btn btn--white btn--block btn--lg btn--pip-accordion btn--has-arrow module-hover-root ${
        openAccordion['project-status'] === true ? 'btn--pip-accordion--on' : ''
      }`}
      type="button"
      onClick={() => handleToggleAccordion('project-status')}
    >
      <span className="btn__content u--display-flex u--align-items-center u--justify-content-space-between u--padding-left-20 u--padding-right-20 u--padding-top-5 u--padding-bottom-5 u--height-auto">
        <span className="btn__text">Update Project Status</span>
        <span className="btn__arrow"></span>
      </span>
    </button>
    <div
      className={
        openAccordion['project-status'] === true
          ? 'u--display-block u--padding-top-20 u--squash-end u--padding-bottom-10'
          : 'u--display-none'
      }
    >
      <p className="u--margin-0">Project Status:</p>
      <div className="form__field u--margin-bottom-20">
        <div className="form__select form__select--lg form__select--no-shadow">
          <select
            className="form__input form__input--lg"
            defaultValue={projectData.status}
            onChange={(event) => setNewProjectStatus(event.target.value)}
          >
            {Array.from([
              'Active',
              'Submitted',
              'Incomplete',
              'Approved',
              'Completed'
            ]).map((status, index) => (
              <option key={index} value={status}>
                {status}
                {status === projectData.status ? ' [current status]' : ''}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div
        className="form__field u--margin-bottom-20"
        style={{ maxWidth: '600px' }}
      >
        <textarea
          type="textarea"
          className="form__textarea form__textarea--no-shadow"
          placeholder="(Send additional message to this project with this status change.)"
          value={projectMessage}
          onChange={(event) => setProjectMessage(event.target.value)}
        />
      </div>
      <button
        id="pip-add__save"
        className="btn btn--lg btn--gold module-hover-root"
        type="button"
        onClick={() => handleUpdateStatus()}
        disabled={projectData.status === newProjectStatus}
      >
        <span className="btn__content">
          <span className="btn__text">Update Status</span>
        </span>
      </button>
    </div>
  </div>
);

export default UpdateProjectStatus;
